import { List } from 'immutable';

import { currentOrLegacyReportState } from './currentOrLegacyReport/state';
import { currentOrLegacySavedViewState } from './currentOrLegacySavedView/state';

export const state = List([currentOrLegacyReportState, currentOrLegacySavedViewState]) as any;

export * from './currentOrLegacyReport/state';
export * from './currentOrLegacySavedView/state';
